import React, { useState, useRef, useMemo } from "react";
import ReactQuill from "react-quill";
import { storage } from "../../../helpers/Firebase";

const quillModules = {
  toolbar: [
    ["bold", "italic", "underline", "strike"],
    [
      { list: "ordered" },
      { list: "bullet" },
      { indent: "-1" },
      { indent: "+1" },
    ],
    ["image"],
  ],
};

const quillFormats = [
  "header",
  "bold",
  "italic",
  "underline",
  "strike",
  "list",
  "bullet",
  "indent",
  "align",
  "image",
];

const RichText = ({ value, updateValue, refURL }) => {
  const [cursorIndex, setCursorIndex] = useState();
  const modules = useMemo(
    () => ({
      toolbar: {
        container: quillModules.toolbar,
        handlers: {
          image: () => {
            onImageUpload();
          },
        },
      },
    }),
    []
  );
  const richTextRef = useRef();

  const ref = storage.ref(refURL);

  const uploadFiles = async (uploadFileObj, filename) => {
    const timeStamp = Date.now();

    const imageRef = ref.child(`${filename}_${timeStamp}`);

    imageRef.put(uploadFileObj).then(
      async () => {
        const downloadURL = await imageRef.getDownloadURL();

        richTextRef.current
          .getEditor()
          .insertEmbed(cursorIndex + filename, "image", downloadURL);
        richTextRef.current.getEditor().focus(cursorIndex);
      },
      (e) => {
        console.log("ERROR", e);
      }
    );
  };

  const onImageUpload = async () => {
    setCursorIndex(
      richTextRef.current.getEditorSelection()
        ? richTextRef.current.getEditorSelection().index
        : richTextRef.current.getEditor().getLength()
    );

    const input = document.createElement("input");

    input.setAttribute("type", "file");
    input.setAttribute("accept", "image/*");
    input.click();

    input.onchange = async () => {
      var file = input.files[0];

      var fileName = file.name;

      const res = await uploadFiles(file, fileName);
    };
  };

  return (
    <div style={{ height: "500px" }}>
      <ReactQuill
        className="mb-2"
        theme="snow"
        style={{ height: "80%" }}
        ref={richTextRef}
        value={value}
        onChange={(val) => {
          updateValue(val);
        }}
        modules={modules}
        formats={quillFormats}
      />
    </div>
  );
};

export default RichText;
